module.exports = __webpack_public_path__ + "img/icon-question-media-hover.ebb84b1f.svg";